export { EventDetailsV2 } from './event-details-v2';
